<template>
    <div class="withdrawal-error__container">
        <div class="notice">
            <!-- eslint-disable-next-line  -->
            {{ $t(`You do not meet the withdrawal requirements. Please check your account information and try again.`) }}
        </div>
        <Illustration xl image="/static/img/illustrations/withdrawal__error.svg"/>
        <div class="button-group">
            <button
                @click="closeAllModals"
                class="btn btn__secondary"
            >
                {{ $t('cancel') | upperCase }}
            </button>
            <button
                @click="goToMyAccount"
                class="btn btn__primary"
            >
                {{ $t('my account') | upperCase }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { routeNames } from '@app/router';

    export default {
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            ...mapActions('ui/modal', [
                'closeAllModals',
            ]),
            goToMyAccount() {
                this.closeAllModals();
                this.$router.push({ name: routeNames.profile });
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/withdrawal/WithdrawalErrorModal.vue